/* @refresh reload */
import * as Sentry from '@sentry/solid';
import { AVCliper } from '@webav/av-pro';
import { render } from 'solid-js/web';
import { registerSW } from 'virtual:pwa-register';

import App from './App.tsx';
import './index.css';
import './lib/i18n.ts';

Sentry.init({
  dsn: 'https://706e1f22459cd58ef84e72b66dd172f9@o4510747334279168.ingest.us.sentry.io/4510747336638464',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  // 仅在生产或测试环境开启
  enabled: !import.meta.env.DEV,
  environment: import.meta.env.MODE,
});

AVCliper.Log.setLogLevel(AVCliper.Log.warn);

const root = document.getElementById('root');

render(() => <App />, root!);

// Aggressive PWA update: register immediately and auto-reload when a new SW controls the page
registerSW({ immediate: true })();
